angular.module('tradersyard').directive('likeForm', [
    '$parse',
    'graph-like-factory',
    '$timeout',
    function ($parse, $client, $timeout) {
        return {
            link: function ($scope, $element, $attr) {
                $scope.client = undefined;

                $timeout(function () {
                    $scope.client = $client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));

                    makeUIView();
                });

                function makeUIView() {
                    $element[$parse($attr.entryIm)($scope) ? 'addClass' : 'removeClass']($attr.activeClass);
                }

                $element.bind('click', function () {
                    if ($parse($attr.entryIm)($scope) === true) {
                        $scope.client.unlike().then(function (response) {
                            if (response.data.state === 0) {
                                if ($attr.entryIm) $parse($attr.entryIm).assign($scope, false);

                                if ($attr.entryCount)
                                    $parse($attr.entryCount).assign(
                                        $scope,
                                        parseInt(
                                            $parse($attr.entryCount)($scope) ? $parse($attr.entryCount)($scope) : 0
                                        ) - 1
                                    );

                                makeUIView();
                            }
                        });
                    } else {
                        $scope.client.like().then(function (response) {
                            if (response.data.state === 0) {
                                if ($attr.entryIm) $parse($attr.entryIm).assign($scope, true);

                                if ($attr.entryCount)
                                    $parse($attr.entryCount).assign(
                                        $scope,
                                        parseInt(
                                            $parse($attr.entryCount)($scope) ? $parse($attr.entryCount)($scope) : 0
                                        ) + 1
                                    );

                                makeUIView();
                            }
                        });
                    }
                });
            },
        };
    },
]);
